import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import {
  TXTWCL_HelloX_how_can_we_helpX,
  TXTWCL_Hello_N0X_how_can_we_helpX
} from './Welcome.messages.json';

const Welcome: React.FC = () => {
  const userId = useSelector(select.account.getUserId);
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  return isAuthenticated ? (
    <Translation tagName="h2" values={{ 0: userId }} {...TXTWCL_Hello_N0X_how_can_we_helpX} />
  ) : (
    <Translation tagName="h2" {...TXTWCL_HelloX_how_can_we_helpX} />
  );
};

export default Welcome;
